import {
  Action,
  ActionType,
  IUploadCSVClassChangeResponse,
} from "models/classchangemanagement/uploadCSV";
import createReducer from "../../createReducer";

export interface UploadCSVClassChangeReducerType {
  loading: boolean;
  error?: string;
  uploadCSVClassChangeResponse?: IUploadCSVClassChangeResponse;
}

const defaultState: UploadCSVClassChangeReducerType = {
  loading: false,
  error: undefined,
  uploadCSVClassChangeResponse: undefined,
};

export const uploadCSVClassChangeReducer =
  createReducer<UploadCSVClassChangeReducerType>(defaultState, {
    [ActionType.UPLOAD_CSV_CLASS_CHANGE](
      state: UploadCSVClassChangeReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPLOAD_CSV_CLASS_CHANGE_ERROR](
      state: UploadCSVClassChangeReducerType,
      action: Action<IUploadCSVClassChangeResponse>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        uploadCSVClassChangeResponse: action.payload,
      };
    },

    [ActionType.UPLOAD_CSV_CLASS_CHANGE_SUCCESS](
      state: UploadCSVClassChangeReducerType,
      action: Action<IUploadCSVClassChangeResponse>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        uploadCSVClassChangeResponse: action.payload,
      };
    },

    [ActionType.UPLOAD_CSV_CLASS_CHANGE_RESET](
      state: UploadCSVClassChangeReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
      };
    },
  });
